import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconWellConnectionSizeS from './IconWellConnection_size_s';

const props: CreateIconArguments = {
  l: IconWellConnectionSizeS,
  m: IconWellConnectionSizeS,
  s: IconWellConnectionSizeS,
  xs: IconWellConnectionSizeS,
  name: 'IconWellConnection',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
